module.exports = __webpack_public_path__ + "static/media/women.4107cd9f.png";